import Intro from "../../../../src/components/v8/intro";
import * as React from 'react';
export default {
  Intro,
  React
};